import React, { useEffect, useRef, useState } from "react";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs } from "../features/blogs/blogSlice";
 import {  Link, useNavigate } from "react-router-dom";
 import "react-multi-carousel/lib/styles.css";
  import Meta from "../components/Meta";
import Counter from "../components/Counter";
import about2 from "../images/about/qentrain-about.jpeg"
import about1 from "../images/cover5.jpg"
import { BiPhoneCall } from "react-icons/bi";
import { TiTick } from "react-icons/ti";
import { FaPlay } from "react-icons/fa";
 import "../styles/blogs.css"
 import "../styles/aboutUs.css"
 import "../styles/couch.css"
 import "../styles/services.css"
 import "../styles/chooseUs.css"
 import "../styles/testimonial.css"
import coach1 from "../images/kahenya/p.JPG"
import coach2 from "../images/kahenya/kahenya1.jpeg"
 
import chooseCover from "../images/cover4.jpg"
import Testimonial from "../components/Testimonials";
import { CiCalendar } from "react-icons/ci";
 
import { MdBusinessCenter } from "react-icons/md";
import { FaLightbulb, FaChalkboardTeacher } from "react-icons/fa";
import { TbChartLine } from "react-icons/tb";
import { GiMoneyStack } from "react-icons/gi";
import { HiUsers } from "react-icons/hi";
import  { FaPhoneAlt } from 'react-icons/fa';
 import moment from "moment";
import UpcomingForums from "../components/UpcomingForums";
import BlogCard from "../components/BlogCard";
import BlogCard2 from "../components/Blog2Card";
import BlogCard1 from "../components/Blog1Card";
import { FaWhatsapp } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
 import loader from "../images/loader/loader1.jpg";
 import {useMediaQuery} from "react-responsive"


function countWords(text) {
  return text.split(/\s+/).filter(word => word !== '').length;
}

const Home = () => {
    const navigate=useNavigate()
    const blogState = useSelector((state) => state?.blog?.blog) || [];
   
    const col1Blogs = blogState?.filter(blog => blog.category === "col-1").slice(0, 2);
  const col2Blogs = blogState?.filter(blog => blog.category === "col-2").slice(0, 3);
    const [loading, setLoading] = useState(true);
  const isDesktop = useMediaQuery({minWidth: 784})
   useEffect(() => {
  dispatch(getAllBlogs());
   }, []);
 
 
  const dispatch = useDispatch();
  useEffect(() => {
    getblogs();
    
   
   
  }, []);
  const getblogs = () => {
    dispatch(getAllBlogs());
  };
   

  const [isModalOpen, setIsModalOpen] = useState(false);

  
  const showVideoModal = () => {
    setIsModalOpen(true);
  };

  
  const closeVideoModal = () => {
    setIsModalOpen(false);
  };

   const handleWhatsAppEnquiry = () => {
    const businessName = "Qentrain Solutions Ltd";
    const message = encodeURIComponent(
      `Hello ${businessName},\n\nI would like to schedule a consultation with one of your experts in Agri-Food & ISO Standards.\n\nPlease let me know the next available slot and any required details.\n\nThank you.`
    );
    const phoneNumber = "254720350903";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

 

  return (
    <>
      <Meta title={"Qentrain"} />

      <Container className="home-wrapper-1">
  <div className="background-slider">
    <div className="slider-overlay"></div>
    <div className="background-image image-1"></div>
    <div className="background-image image-2"></div>
    <div className="background-image image-3"></div>

    </div>
    <div className="content-wrapper">
  <span>Quality and Safety is Our Business</span>
  <h2>Expert Agri-Food Training & Consultancy Solutions</h2>
  <p>Enhancing Africa's agri-food enterprises through certifications, training, product development, and process improvement for competitiveness production and processing.</p>
  
  <Link to="/courses" className="cta-button">Our Programs</Link>
</div>

  <Counter/>
</Container>

<Container className="homer-wrapper-1">
  <div className="about-us-wrapper">
    <div className="about-us-image">
          <LazyLoadImage
            alt='Qentrain Solutions'
            effect="blur"
            src={about1 || loader}
            placeholderSrc={loader}
            width="100%"
            height="100%"
            className="img-fluid mx-auto img-el"
          />
    </div>
    <div className="about-us-content">
    <div className="about-us-header">
        <span>Your Trusted Agri-Food Partner</span>
        <h2>Driving Excellence in Food Safety & Quality Across Africa</h2>
        <p>Qentrain Solutions Ltd is a leading technical consultancy firm specializing in certifications, training, product development, and process optimization for agri-food enterprises. </p>
      </div>
      <div className="about-us-content-el">
        <div className="about-us-content-el-1">
          <div className="about-us-img-el">
                  <LazyLoadImage
                    alt='Qentrain Solutions'
                    effect="blur"
                    src={about2 || loader}
                    placeholderSrc={loader}
                    width="100%"
                    height="300px"
                    className="img-fluid mx-auto img-el"
                  />
            <div className="play-button-wrapper-el">
              <div className="play-button-wrapper">
                <div className="circle-animation">
                  <div className="circle one"></div>
                  <div className="circle two"></div>
                </div>
                <span className="play-button" >
                  <FaPlay className="play-icon"/>
                </span>
              </div>
            </div>
          </div>
          <div className="about-us-button-wrapper">
           <Link to="/about"  className="about-us-button">
          Learn More
           </Link>
            
            <span>
              <a href="tel:+254720350903 "><BiPhoneCall className="call-icon"/> +254-720350903 </a>
            </span>
          </div>
          {isModalOpen && (
            <div className="video-modal-overlay" onClick={closeVideoModal}>
              <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/8DVKDseEF4M?si=EiKSh6YZHX0SDWga" 
                  title="Video Player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <button className="modal-close" onClick={closeVideoModal}>
                &times;
              </button>
            </div>
          )}
        </div>
        <div className="about-us-content-el-2">
          <p>With a team of seasoned experts, we empower businesses to achieve compliance, efficiency, and market competitiveness.</p>
          <p>"At Qentrain Solutions Ltd, we believe in practical, cost-effective solutions that drive business success."</p>
          <ul>
            <li>
              <TiTick className="tick-icon" /> Expert Consultation & Training
            </li>
            <li>
              <TiTick className="tick-icon" /> Practical Business Solutions
            </li>
            <li>
              <TiTick className="tick-icon" /> Sustainable Growth Strategies
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</Container>


 
  
  <Container className="homer-wrapper-1">
  <div className="services-wrapper">
    <div className="services-header">
      <span>Our Consultancy Services</span>
      <h2>Comprehensive Solutions for Agri-Food Enterprises</h2>
    </div>

    <div className="services-cards-wrapper">
    <div className="service-card">
        <div className="service-content">
          <FaChalkboardTeacher className="services-icon"/>
          <h3>Training & Capacity Building</h3>
          <p>Equipping individuals and enterprises with the skills to excel in food production and processing.</p>
        </div>
      </div>
      <div className="service-card">
        <div className="service-content">
          <FaLightbulb className="services-icon"/>
          <h3>Product Design & Development</h3>
          <p>Innovative solutions to enhance product quality, efficiency, and marketability in agri-food processing.</p>
        </div>
      </div>
      <div className="service-card">
        <div className="service-content">
          <HiUsers className="services-icon"/>
          <h3>Market Access & Strategy</h3>
          <p>Helping businesses expand their reach and competitiveness in the agri-food industry.</p>
        </div>
      </div>
      <div className="service-card">
        <div className="service-content">
          <MdBusinessCenter className="services-icon"/>
          <h3>Business Modelling & Planning</h3>
          <p>Strategic guidance in developing sustainable business models and actionable plans for growth.</p>
        </div>
      </div>

      <div className="service-card">
        <div className="service-content">
          <TbChartLine className="services-icon"/>
          <h3>Financial Management</h3>
          <p>Expert financial planning, budgeting, and management to optimize business operations.</p>
        </div>
      </div>
      <div className="service-card">
        <div className="service-content">
          <GiMoneyStack className="services-icon"/>
          <h3>Accounting & Compliance</h3>
          <p>Ensuring businesses meet financial and regulatory requirements through sound accounting practices.</p>
        </div>
      </div>

    </div>
  </div>
</Container>




  

  <Container className="homer-wrapper-1">
    <div className="coach-wrapper">
    <div className="coach-content">
  <span>Meet Our Consultant</span>
  <h2>Industry-Leading Expertise in Agri-Food & ISO Standards</h2>
  <p>
    Leveraging 15+ years of hands-on experience in food processing, safety, and quality management, our certified experts have trained and consulted for major African enterprises including <strong>Brookside Dairy, Bidco Oil Refineries, and SNV</strong>. We deliver science-backed solutions aligned with international standards.
  </p>
  
    

          <button className="cta-button" onClick={handleWhatsAppEnquiry}>
            <FaWhatsapp className="button-icon" /> Schedule Consultation
          </button>
</div>

      <div className="coach-image-wrapper">
       
        <div className="coach-image-container">
             <LazyLoadImage
               alt='Qentrain Solutions'
               effect="blur"
               src={coach1 || loader}
               placeholderSrc={loader}
               width="100%"
               height="100%"
               className="img-fluid mx-auto img-el"
             />
        </div>
      <div className="coach-image-container">
          <LazyLoadImage
            alt='Qentrain Solutions'
            effect="blur"
            src={coach2 || loader}
            placeholderSrc={loader}
            width="100%"
            height="100%"
            className="img-fluid mx-auto img-el"
          />
      </div>
 

      </div>
      <div className="cta-button-container" onClick={handleWhatsAppEnquiry}>
      <button className="cta-button-2">
    <FaWhatsapp className="button-icon"/> Schedule Consultation
  </button>
      </div>

    </div>
  </Container>

  


<Container className="home-wrapper-1">
    <div className="elementor-wrapper">
        <div className="elementor-header">
        <span>Why Choose Us</span>
        <h2>Empowering Agri-Food Enterprises with Best Solutions</h2>
        </div>
        <div className="elementor-wrapper-el">
                        <LazyLoadImage
                    alt='Qentrain Solutions'
                    effect="blur"
                    src={chooseCover || loader}
                    placeholderSrc={loader}
                    width={isDesktop ? "30%": "100%"}
                    height="100%"
                    className="img-fluid mx-auto img-el"
                  />
            <div className="elementor-cards">
            <div className="elementor-card">
                    <div className="elementor-content">
                    <h3>Industry Expertise</h3>
                    <p>We bring years of experience in training and consultancy, specializing in food production and processing.</p>
                    </div>
                </div>
                <div className="elementor-card">
                    <div className="elementor-content">
                    <h3>Commitment to Quality</h3>
                    <p>We prioritize delivering high-quality and cost-effective solutions that enhance business competitiveness.</p>
                    </div>
                </div>

                <div className="elementor-card">
                    <div className="elementor-content">
                    <h3>Tailored Business Solutions</h3>
                    <p>Our consultancy services are designed to address the specific needs of agri-food enterprises, helping them optimize production and market reach.</p>
                        </div>
                </div>
                <div className="elementor-card">
                    <div className="elementor-content">
                    <h3>Trusted by Businesses</h3>
                    <p>Our proven track record in the agri-food industry makes us a reliable partner for enterprises looking to scale and innovate.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</Container>




 <Testimonial/>

 <UpcomingForums/>


<Container className="home-wrapper-1">
  <div className="blog-wrapper">
    <div className="blog-header">
      <div className="blog-header-el-1">
        <span>Our Blog</span>
        <h2>Food Safety & Quality Resources</h2>
      </div>
      <div>
        <button>
          <Link to="/blogs">
          View All
          </Link>
           
        </button>
      </div>
    </div>

    {(!col1Blogs?.length && !col2Blogs?.length) ? (
   <div className="blog-card-container">
    <div className="blog-card-container-1">
      {[...Array(2)].map((_, index) => (
        <BlogCard1 key={index} loading={true} />
      ))}
    </div>
    <div className="blog-card-container-2">
      {[...Array(3)].map((_, index) => (
        <BlogCard2 key={index} loading={true} />
      ))}
    </div>
  </div>



    ) : (
      <div className="blog-card-container">
        <div className="blog-card-container-1">
          {col1Blogs?.map((blog, index) => (
            <div className="blog-card" key={blog._id}>
              <img src={blog.images?.[0]?.url} alt="blog" />
              <div className="blog-content">
                <span><CiCalendar /> {moment(blog.createdAt).format("MMMM D YYYY")}</span>
                <h2>{blog.title}</h2>
                <p dangerouslySetInnerHTML={{ __html: blog.description.substring(0, 100) + "..." }} />
              <Link to={`/blog/${blog._id}`}>
              <button>Learn More</button>
            </Link>

              </div>
            </div>
          ))}
        </div>

        <div className="blog-card-container-2">
          {col2Blogs?.map((blog, index) => (
        <Link 
          to={`/blog/${blog._id}`} 
          key={blog._id} 
          className="blog-card-2"
          style={{ textDecoration: 'none', color: 'inherit' }} // prevent default link styles
        >
          <img src={blog.images?.[0]?.url} alt="blog" />
          <div className="blog-content-2">
            <span><CiCalendar className="calender-icon" /> {moment(blog.createdAt).format("MMMM D YYYY")}</span>
            <h2 style={{ cursor: "pointer" }}>{blog.title}</h2>
          </div>
        </Link>
          ))}
        </div>
      </div>
    )}
  </div>
</Container>



    </>
  );
};

export default Home;
